import { heroImage } from "@/mocks/homeData";
import { GOOGLE_RATING_LABEL } from "@/pages/home/googleStats";

const EXPERIENCE_ITEMS = [
  {
    icon: "ri-landscape-line",
    title: "Cânions de Capitólio",
    description: "Paredões de pedra que se erguem do lago e rendem as fotos mais marcantes do passeio.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Águas cristalinas",
    description: "Lagoa Azul, Cachoeira da Gruta, Cachoeira das Orquídeas e paradas para banho no meio do Lago de Furnas.",
  },
  {
    icon: "ri-restaurant-line",
    title: "Bares flutuantes",
    description: "Estruturas sobre a água para relaxar, comer e curtir o dia com a família ou o grupo.",
  },
];

export default function LakeFurnasExperience() {
  return (
    <section
      id="experiencia-lago-de-furnas"
      className="relative py-6 md:py-12 bg-background-50 scroll-mt-16"
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-10 items-center">
          <div className="reveal order-1 relative w-full aspect-[16/10] md:aspect-[4/3] rounded-xl overflow-hidden border border-background-200/70">
            <img
              src={heroImage}
              alt="Lancha navegando entre os cânions do Lago de Furnas em Capitólio, Minas Gerais"
              title="A experiência do Lago de Furnas em Capitólio | Eco Tour Turismo"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/45 to-transparent" />
            <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1.5 rounded-full bg-background-50/95 px-2.5 py-1 text-[10px] md:text-xs font-semibold text-primary-900 whitespace-nowrap">
              <i className="ri-map-pin-2-fill text-accent-600" />
              Capitólio · Mar de Minas
            </span>
          </div>

          <div className="reveal reveal-delay-2 order-2">
            <span className="inline-block text-[10px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-1.5 md:mb-3">
              A experiência do Lago de Furnas
            </span>
            <h2 className="text-lg md:text-3xl font-heading font-bold text-primary-900 leading-tight mb-2 md:mb-3">
              Muito mais que um passeio: viva o Mar de Minas
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 md:mb-5">
              O Lago de Furnas é o coração de Capitólio — um mar de água doce entre paredões de pedra,
              cachoeiras e lagoas de água cristalina. Em cada passeio você navega pelos cânions, para nos
              bares flutuantes e encontra aquele visual que só o Mar de Minas tem.
            </p>

            <div className="space-y-2 md:space-y-3 mb-4 md:mb-5">
              {EXPERIENCE_ITEMS.map((item) => (
                <div key={item.title} className="flex items-start gap-2.5 md:gap-3">
                  <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-accent-700 text-base md:text-lg`} />
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-[13px] md:text-base font-heading font-bold text-primary-900 leading-tight mb-0.5">
                      {item.title}
                    </h3>
                    <p className="text-[11px] md:text-sm text-foreground-600 leading-snug md:leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3 md:gap-5 border-t border-background-300/60 pt-3 md:pt-4">
              <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                <span className="font-heading text-base md:text-xl font-bold text-primary-600">+12</span>
                <span className="text-[10px] md:text-xs text-foreground-500">anos no lago</span>
              </div>
              <span className="w-px h-5 bg-background-300/70" />
              <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                <span className="font-heading text-base md:text-xl font-bold text-primary-600">+10.000</span>
                <span className="text-[10px] md:text-xs text-foreground-500">clientes</span>
              </div>
              <span className="w-px h-5 bg-background-300/70" />
              <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                <span className="font-heading text-base md:text-xl font-bold text-primary-600">
                  {GOOGLE_RATING_LABEL}
                </span>
                <span className="text-[10px] md:text-xs text-foreground-500">no Google</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}